const allowList = [
  'popup/create_invoice_from_deal.php',
  'popup/deal.php',
  'popup/employee.php',
  'popup/external_costs_project.php',
  'popup/external_costs_project_bestelbon.php',
  'popup/project.php',
  'popup/inv_invoices.php',
  'popup/timetracking.php',
  'popup/callback.php',
  'popup/todo.php',
  'popup/ticket.php',
  'popup/product.php',
  'popup/pricing_timetracking.php',
  'popup/selectQuotation.php',
  'popup/inv_creditnote.php',
  'popup/meeting.php',
  'popup/inv_projects.php',
  'popup/inv_subscriptions.php',
  'popup/agendaDragHandler.php',
  'popup/inv_invoice_permanent.php',
  'popup/inv_invoice_edit_address.php',
  'popup/presale_offerte.php',
  'popup/ticket_extra_parties.php',
  'popup/discover_quotation_articles.php',
];

const headerFooterShouldBeOverhauled = (url) => Boolean(allowList.find((entry) => url.startsWith(entry)));

export default headerFooterShouldBeOverhauled;
